/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserList
 */
export interface UserList {
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userImage: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userEmployeeId: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userLastName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userFirstName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userJobTitle: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userNfcTokenDescription: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userNfcToken: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userFleetRole: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userLicenseExpiryDate: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    userExpiryLogout: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    departmentLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    shiftLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserList
     */
    siteLabel: boolean;
}

/**
 * Check if a given object implements the UserList interface.
 */
export function instanceOfUserList(value: object): value is UserList {
    if (!('userImage' in value) || value['userImage'] === undefined) return false;
    if (!('userEmployeeId' in value) || value['userEmployeeId'] === undefined) return false;
    if (!('userLastName' in value) || value['userLastName'] === undefined) return false;
    if (!('userFirstName' in value) || value['userFirstName'] === undefined) return false;
    if (!('userJobTitle' in value) || value['userJobTitle'] === undefined) return false;
    if (!('userNfcTokenDescription' in value) || value['userNfcTokenDescription'] === undefined) return false;
    if (!('userNfcToken' in value) || value['userNfcToken'] === undefined) return false;
    if (!('userFleetRole' in value) || value['userFleetRole'] === undefined) return false;
    if (!('userLicenseExpiryDate' in value) || value['userLicenseExpiryDate'] === undefined) return false;
    if (!('userExpiryLogout' in value) || value['userExpiryLogout'] === undefined) return false;
    if (!('departmentLabel' in value) || value['departmentLabel'] === undefined) return false;
    if (!('shiftLabel' in value) || value['shiftLabel'] === undefined) return false;
    if (!('siteLabel' in value) || value['siteLabel'] === undefined) return false;
    return true;
}

export function UserListFromJSON(json: any): UserList {
    return UserListFromJSONTyped(json, false);
}

export function UserListFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserList {
    if (json == null) {
        return json;
    }
    return {
        
        'userImage': json['userImage'],
        'userEmployeeId': json['userEmployeeId'],
        'userLastName': json['userLastName'],
        'userFirstName': json['userFirstName'],
        'userJobTitle': json['userJobTitle'],
        'userNfcTokenDescription': json['userNfcTokenDescription'],
        'userNfcToken': json['userNfcToken'],
        'userFleetRole': json['userFleetRole'],
        'userLicenseExpiryDate': json['userLicenseExpiryDate'],
        'userExpiryLogout': json['userExpiryLogout'],
        'departmentLabel': json['departmentLabel'],
        'shiftLabel': json['shiftLabel'],
        'siteLabel': json['siteLabel'],
    };
}

export function UserListToJSON(json: any): UserList {
    return UserListToJSONTyped(json, false);
}

export function UserListToJSONTyped(value?: UserList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userImage': value['userImage'],
        'userEmployeeId': value['userEmployeeId'],
        'userLastName': value['userLastName'],
        'userFirstName': value['userFirstName'],
        'userJobTitle': value['userJobTitle'],
        'userNfcTokenDescription': value['userNfcTokenDescription'],
        'userNfcToken': value['userNfcToken'],
        'userFleetRole': value['userFleetRole'],
        'userLicenseExpiryDate': value['userLicenseExpiryDate'],
        'userExpiryLogout': value['userExpiryLogout'],
        'departmentLabel': value['departmentLabel'],
        'shiftLabel': value['shiftLabel'],
        'siteLabel': value['siteLabel'],
    };
}

